// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import React from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import pluralize from '@tcp/core/src/utils/pluralize';
import withStyles from '../../../hoc/withStyles';
import { Button } from '../../../molecules/Recommendations/styles/Recommendations.style';
import style, { ColorList } from '../styles/FilterColor.style';

// returns the index (or indices) of the item(s) with the given value(s) in the given optionsMap
export function getIndexOrIndicesOfValue(optionsMap, valueOrValues) {
  return Array.isArray(valueOrValues)
    ? optionsMap.map(
        (item) => valueOrValues.findIndex((selectedValue) => item.value === selectedValue) >= 0
      )
    : optionsMap.findIndex((item) => item.value === valueOrValues);
}

// eslint-disable-next-line sonarjs/cognitive-complexity
const FilterColor = (props) => {
  const {
    className,
    optionsMap,
    input,
    isLoadingMore,
    formValues,
    setSelectedFilterName,
    placeholder,
    handleSubmitForm,
  } = props;

  // select the item with the given value
  const setValue = (selectedValue) => {
    const {
      allowMultipleSelections,
      input: { value, onChange, name },
    } = props;

    if (allowMultipleSelections) {
      const newValue = [...value];
      newValue.push(selectedValue);
      // notify our listeners that the user wants the value of this component to change
      onChange(newValue);
      handleSubmitForm(name, newValue);
    } else {
      // only single selection allowed
      if (value !== selectedValue) {
        // if the value to select is not the current value of this component
        // notify our listeners that the user wants the value of this component to change
        onChange(selectedValue);
        handleSubmitForm(name, selectedValue);
      }
      if (!value);
    }
  };

  const unsetValue = (value) => {
    const newValues = input?.value.filter((val) => val !== value);
    // notify our listeners that the user wants the value of this component to change
    input.onChange(newValues);
    handleSubmitForm(input.name, newValues);
  };

  const setItemValue = (onFilterSelection, clickedItemValue) => {
    setValue(clickedItemValue);
  };

  const handleItemClick = (event, clickedItemIndex) => {
    const { allowMultipleSelections, onFilterSelection, isFavoriteView } = props;
    if (!optionsMap[clickedItemIndex]?.disabled) {
      // ignore clicks on disabled items
      const clickedItemValue = optionsMap[clickedItemIndex]?.value;
      const selectedIndex = getIndexOrIndicesOfValue(optionsMap, input?.value);
      const isFavoriteCall = isFavoriteView
        ? allowMultipleSelections && selectedIndex[clickedItemIndex] && !onFilterSelection
        : allowMultipleSelections && selectedIndex[clickedItemIndex];
      if (isFavoriteCall) {
        unsetValue(clickedItemValue);
      } else {
        // set the value (or add to the value if multiple selections is on) of this component to clickedItemValue
        setItemValue(onFilterSelection, clickedItemValue);
      }
    }
  };

  return (
    <section
      className={`${className} ${isLoadingMore ? 'disable-list-items' : ''} filter-color-main `}
    >
      {optionsMap?.map((item, index) => {
        return (
          <ColorList key={item?.title} loadingState={isLoadingMore}>
            <div className="color-container" type="checkbox">
              <Button
                className="color-click"
                onClick={(e) => {
                  e.preventDefault();
                  setTimeout(() => {
                    setSelectedFilterName(placeholder);
                    handleItemClick(e, index);
                  }, 0);
                }}
                disabled={isLoadingMore}
              >
                <DamImage
                  className={`svg-color ${
                    formValues[optionsMap[index]?.name]?.includes(item?.value)
                      ? 'outline selected-color'
                      : item?.class
                  }`}
                  imgData={item.imageData}
                  imgConfigs={item.imageConfig}
                  data-colorname={item.colorName}
                />
                <BodyCopy className="grids color-name" fontSize={['fs16']} fontFamily="secondary">
                  {pluralize(item.title?.toLowerCase())}
                </BodyCopy>
              </Button>
            </div>
          </ColorList>
        );
      })}
    </section>
  );
};

FilterColor.propTypes = {
  className: PropTypes.string.isRequired,
  isFavoriteView: PropTypes.bool,
  allowMultipleSelections: PropTypes.bool,
  onFilterSelection: PropTypes.func,
  input: PropTypes.shape({ value: {}, onChange: () => {} }),
  optionsMap: PropTypes.shape([]),
  isLoadingMore: PropTypes.bool,
  formValues: PropTypes.shape({}),
  placeholder: PropTypes.string,
  setSelectedFilterName: PropTypes.func,
};
FilterColor.defaultProps = {
  isFavoriteView: false,
  allowMultipleSelections: false,
  onFilterSelection: () => {},
  input: {},
  optionsMap: [],
  isLoadingMore: false,
  formValues: {},
  placeholder: '',
  setSelectedFilterName: () => {},
};

export default withStyles(FilterColor, style);
export { FilterColor as FilterColorVanilla };
